export const HEADER_TOOLTIP_CLICKED: "Onboarding.MyGrails.HEADER_TOOLTIP_CLICKED" =
  "Onboarding.MyGrails.HEADER_TOOLTIP_CLICKED";
export type HeaderTooltipClickedAction = {
  type: typeof HEADER_TOOLTIP_CLICKED;
};
